module.exports = __webpack_public_path__ + "static/media/talk.dd27cc65.png";